import { render, staticRenderFns } from "./SyncSettings.vue?vue&type=template&id=0a47abd1"
import script from "./SyncSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SyncSettings.vue?vue&type=style&index=0&id=0a47abd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports